// extracted by mini-css-extract-plugin
export var cartContainer = "_gi-4";
export var gray = "_gi-1";
export var itemContainer = "_gi-2";
export var itemDetails = "_gi-3";
export var strong = "_gi-0";